import { useArticleMediaViewer } from '../useArticleMediaViewer';
import { Box, Typography } from '@mui/material';
import RichTextDisplay from '../../richText/RichTextDisplay';
import ContentMediaGallery from '../../contentMedia/ContentMediaGallery';
import { getContentGalleryItems } from '../../../utils/contentMediaUtils';
import '../../../css/articleFolder/publicArticleFolder.css';
import '../../../css/machines/modeEtConsigne.css';

const PublicArticleItems = ({ articleFolderItem }) => {
    const { openArticleMedia, mediaViewer } = useArticleMediaViewer();
    const items = Array.isArray(articleFolderItem) ? articleFolderItem : [];

    if (items.length === 0) {
        return null;
    }

    return (
        <Box sx={{ backgroundColor: '#FFFFFF', margin: '30px 0px 10px 0px', borderRadius: '8px', padding: '20px' }}>
            <Box className='modeEtConsigne_edit_box' sx={{ marginBottom: '20px' }}>
                <Typography className='modeEtConsigne_title'>Articles</Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {items.map((item) => (
                    <Box
                        key={item.id}
                        sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', backgroundColor: '#F6F6F6', borderRadius: '8px', padding: '10px' }}
                    >
                        <Typography className='publicArticleFolder_articleTitle'>{item?.title}</Typography>
                        <RichTextDisplay html={item?.description} />
                        {getContentGalleryItems(item).length > 0 && (
                            <ContentMediaGallery
                                readOnly
                                items={getContentGalleryItems(item)}
                                onOpen={(index) => openArticleMedia(item, index)}
                            />
                        )}
                    </Box>
                ))}
            </Box>

            {mediaViewer}
        </Box>
    );
};

export default PublicArticleItems;
